export default "__VITE_PUBLIC_ASSET__da464c84__"